import { render } from "./AdvertisingPolicy.vue?vue&type=template&id=3912e475&scoped=true&ts=true&lang=pug"
import script from "./AdvertisingPolicy.vue?vue&type=script&lang=ts"
export * from "./AdvertisingPolicy.vue?vue&type=script&lang=ts"

import "./AdvertisingPolicy.vue?vue&type=style&index=0&id=3912e475&lang=css&scoped=true"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3912e475"]])

export default __exports__